import { useTranslation } from "react-i18next";

import SendToFields from "components/SendToFields";

const SendToField = ({ showBccField, showCcField, showSendToTextField }) => {
  const { t } = useTranslation();

  if (!showSendToTextField && !showBccField && !showCcField) return null;

  return (
    <SendToFields
      showCcBccButton
      showBccField={showSendToTextField ? false : showBccField}
      showCcField={showSendToTextField ? false : showCcField}
      showSendToField={showSendToTextField}
      bccInputProps={{
        label: t("neetoMolecules.emailForm.labels.bCc"),
        name: "sendToBcc",
        placeholder: t(
          "neetoMolecules.emailForm.placeholders.commaSeparatedEmails"
        ),
      }}
      ccInputProps={{
        label: t("neetoMolecules.emailForm.labels.cc"),
        name: "sendToCc",
        placeholder: t(
          "neetoMolecules.emailForm.placeholders.commaSeparatedEmails"
        ),
      }}
      emailInputProps={{
        id: "sendTo",
        name: "sendTo",
        label: t("neetoMolecules.emailForm.labels.sendTo"),
        placeholder: t(
          "neetoMolecules.emailForm.placeholders.commaSeparatedEmails"
        ),
        required: true,
      }}
    />
  );
};

export default SendToField;
